import { IIconProps } from 'src/interfaces/IconProps';

const CloseIcon = ({ width = 15, height = 20, color = '#fff', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      // eslint-disable-next-line max-len
      d='M13.8326 0.167368C14.0558 0.390524 14.0558 0.752333 13.8326 0.97549L7.80812 7L13.8326 13.0245C14.0558 13.2477 14.0558 13.6095 13.8326 13.8326C13.6095 14.0558 13.2477 14.0558 13.0245 13.8326L7 7.80812L0.97549 13.8326C0.752333 14.0558 0.390524 14.0558 0.167368 13.8326C-0.0557892 13.6095 -0.0557892 13.2477 0.167368 13.0245L6.19188 7L0.167368 0.97549C-0.0557892 0.752333 -0.0557892 0.390525 0.167368 0.167368C0.390524 -0.0557889 0.752333 -0.0557889 0.97549 0.167368L7 6.19188L13.0245 0.167368C13.2477 -0.0557892 13.6095 -0.0557892 13.8326 0.167368Z'
      fill={color}
    />
  </svg>
);

export default CloseIcon;
